import { Row, Col } from "antd";
import React, { Component } from "react";
import i18n from "../../../i18n/";
import TotalInformation from "../../../components/report/individual_user/TotalInformation";
import FrequencyGraph from "../../../components/report/FrequencyGraph";
import Layout from "../../../components/layout/Layout";
import PopularTopic from "../../../components/report/PopularTopic";
import GenderSummaryBox from "../stress/GenderSummaryBox";
import { ProgressChartInner } from "../counseling/CounselingProgressChart";
import { Container } from "../individual_user/style";

class PeopleOverviewComp extends Component {
    state = {}

    render() {
    	const { id, data, isVertical } = this.props;
    	return (
    		<Row gutter={16}>
    			<Col md={24} lg={24} xl={isVertical ? 24 : 12}>
    				<GenderSummaryBox data={data && data.gender ? data.gender : undefined} visualColorKey={id} />
    				<Row>
    					<Col span={24}>
    						<FrequencyGraph
    							containerStyle={{ marginTop: 0 }}
    							visualColorKey={id}
    							data={data ? data.frequency : null}
    							date_range={data ? data.date_range : null}
    							chart_id={`people_overview_frequency_graph_${id}`} />
    					</Col>
    				</Row>
    			</Col>
    			<Col md={24} lg={24} xl={isVertical ? 24 : 12}>
    				<Container style={{marginTop:0, height:396, maxHeight:396}}>
    					<ProgressChartInner
    						header={i18n.t("popular_topic")} 
    						showHeader
    						colorType={id}
    						data={data ? data.topic : []} 
    					/>
    				</Container>
    				{/* <PopularTopic
                        id={id} data={data ? data.topic : null} /> */}
    			</Col>
    		</Row>
    	);
    }
}

// const mapStateToProps = state => ({
//     organizationLoading: state.organization.loading,
//     category_title: {
//         category1_title: state.organization.organization.category1_title,
//         category2_title: state.organization.organization.category2_title,
//         category3_title: state.organization.organization.category3_title,
//         category4_title: state.organization.organization.category4_title
//     },
//     choice: {
//         choice1: state.organization.organization.choice1,
//         choice2: state.organization.organization.choice2,
//         choice3: state.organization.organization.choice3,
//         choice4: state.organization.organization.choice4,
//     }
// });

export default PeopleOverviewComp;


// WEBPACK FOOTER //
// ./src/components/report/people_overview/PeopleOverviewComp.js